export const listenWindowMixins = {
  data () {
    return {
      clientWidth: true
    }
  },
  methods: {
    handleResize () {
      this.clientWidth = window.innerWidth > 1000
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  },
  mounted: function () {
    // 监听屏幕宽度和高度变化
    window.addEventListener('resize', this.handleResize, true)
  }
}



// WEBPACK FOOTER //
// ./src/mixin/listenWindow.js